<footer class="footer-container">
  <div class="footer-left">
    <p class="build-version">Version: @project.version@</p>
    <p class="copyright">National Marrow Donor Program &#8211; Entrusted to operate the C.W. Bill Young Cell
      Transplantation Program.</p>
  </div>
  <div class="footer-right">
    <ul class="terms-of-use-links">
      <li><a class="kpi-button" [routerLink]="['/kpi/dashboard']">KPI Dashboard</a></li>
      <li class="separator"></li>
      <li *ngIf="userInfo && userInfo.internalUser"><a [routerLink]="['/admin/announcements']">Admin</a></li>
      <li *ngIf="userInfo && userInfo.internalUser" class="separator"></li>
      <li><a href="https://nmdp.org/terms-of-use" target="_blank" rel="noopener noreferrer">Terms of Use</a></li>
      <li class="separator"></li>
      <li><a href="https://nmdp.org/privacy" target="_blank" rel="noopener noreferrer">Privacy Policy</a></li>
      <li class="separator"></li>
      <li><a href="https://nmdp.org/about-us/careers/working-with-us" target="_blank" rel="noopener noreferrer">EEO/Affirmative Action
        Employer</a></li>
    </ul>
    <p class="copyright">Copyright &copy; 1996-{{currentYear}} National Marrow Donor Program. All Rights Reserved.</p>
  </div>
</footer>
